import { render, staticRenderFns } from "./NewReseller.vue?vue&type=template&id=5375224c"
import script from "./NewReseller.vue?vue&type=script&lang=js"
export * from "./NewReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports